import MuiTableHead from '@mui/material/TableHead';
import type { ReactNode } from 'react';

export interface TableHeadProps {
  children: ReactNode;
}

// Header section of a Table behind the facade.
export function TableHead({ children }: TableHeadProps) {
  return <MuiTableHead>{children}</MuiTableHead>;
}
